import { benchmarkScore } from './types';

export const requestPostBenchmarkData = (payload, promise) => ({
  type: benchmarkScore.request,
  payload,
  promise,
});

export const requestPostBenchmarkDataSuccess = (businessScore) => ({
  type: benchmarkScore.success,
  businessScore,
});

export const requestPostBenchmarkDataFailure = (error) => ({
  type: benchmarkScore.failure,
  error,
});
